import React, {Component}  from 'react';
import {Route, Switch} from 'react-router-dom';
import {view as Knowledge} from './knowledge'
import {view as Assist} from './assist'
import {view as WordBank} from './wordBank'
import {view as albumManage} from './album'
import {view as articleManage} from './article'


import './style.css'

class QuestionBox extends Component{
    render(){
        return(
            <div style={{paddingLeft:'10px',fontSize:0,marginRight:'10px',paddingTop:'10px'}}>
                <div>
                    <Switch>
                        <Route exact path="/knowledgeAssist/treeManage" component={Knowledge}/>
                        <Route exact path="/knowledgeAssist/assistManage" component={Assist}/>
                        <Route exact path="/knowledgeAssist/wordBankManage" component={WordBank}/>
                        <Route exact path="/knowledgeAssist/albumManage" component={albumManage}/>
                        <Route exact path="/knowledgeAssist/articleManage" component={articleManage}/>

                    </Switch>
                </div>
            </div>
        );
    }
}

export default QuestionBox


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/view.js